import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-4xl text-foreground-900 mb-3">
          随时随地看韩漫
        </h2>
        <p className="text-sm md:text-base text-foreground-500 mb-8 max-w-lg mx-auto">
          支持手机、平板、电脑全平台阅读，下拉式流畅体验，无删减完整内容
        </p>
        <Link
          to="/category/completed"
          className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
        >
          开始阅读 <i className="ri-arrow-right-line"></i>
        </Link>

        <div className="mt-12 flex items-center justify-center gap-4 md:gap-8 flex-wrap">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-100">
              <i className="ri-smartphone-line text-secondary-600 text-sm"></i>
            </div>
            <span className="text-xs text-foreground-500 whitespace-nowrap">手机阅读</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100">
              <i className="ri-tablet-line text-accent-600 text-sm"></i>
            </div>
            <span className="text-xs text-foreground-500 whitespace-nowrap">平板阅读</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100">
              <i className="ri-computer-line text-primary-600 text-sm"></i>
            </div>
            <span className="text-xs text-foreground-500 whitespace-nowrap">电脑阅读</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-100">
              <i className="ri-download-line text-secondary-600 text-sm"></i>
            </div>
            <span className="text-xs text-foreground-500 whitespace-nowrap">离线缓存</span>
          </div>
        </div>

        <div className="mt-10 relative h-32 md:h-40 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-transparent to-background-50 z-10"></div>
          <div className="flex gap-4 animate-scroll">
            {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
              <div key={i} className="w-20 md:w-24 h-28 md:h-36 flex-shrink-0 rounded-lg bg-background-100 border border-background-200 overflow-hidden">
                <div className="w-full h-full bg-gradient-to-br from-secondary-100/60 to-accent-100/40"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}